module.exports = __webpack_public_path__ + "static/media/G1-38-Esconderijo-das-Amazonas-cod79.612a0731.png";